"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.askAcknowledgementAllowedTypes = exports.REMINDER_ACTIONS = exports.NON_CONTEXT_MENU_ACTION = exports.MESSAGE_CONTEXT_MENU = void 0;
const models_1 = require("../models");
// export type ContextMenuType = keyof typeof MESSAGE_CONTEXT_MENU;
var MESSAGE_CONTEXT_MENU;
(function (MESSAGE_CONTEXT_MENU) {
    MESSAGE_CONTEXT_MENU["INFO"] = "INFO";
    MESSAGE_CONTEXT_MENU["ASK_ACKNOWLEDGEMENT"] = "ASK_ACKNOWLEDGEMENT";
    MESSAGE_CONTEXT_MENU["STAR_MESSAGE"] = "STAR_MESSAGE";
    MESSAGE_CONTEXT_MENU["UNSTAR_MESSAGE"] = "UNSTAR_MESSAGE";
    MESSAGE_CONTEXT_MENU["FORWARD_MESSAGE"] = "FORWARD_MESSAGE";
    MESSAGE_CONTEXT_MENU["DELETE_MESSAGE"] = "DELETE_MESSAGE";
    MESSAGE_CONTEXT_MENU["EDIT"] = "EDIT";
    MESSAGE_CONTEXT_MENU["REPLY"] = "REPLY";
    MESSAGE_CONTEXT_MENU["VISIBLE_TO_PATIENT"] = "VISIBLE_TO_PATIENT";
    MESSAGE_CONTEXT_MENU["VISIBLE_TO_PHYSICIAN"] = "VISIBLE_TO_PHYSICIAN";
    MESSAGE_CONTEXT_MENU["COPY"] = "COPY";
    MESSAGE_CONTEXT_MENU["RESEND"] = "RESEND";
    MESSAGE_CONTEXT_MENU["RESEND_AS_PRIORITY"] = "RESEND_AS_PRIORITY";
})(MESSAGE_CONTEXT_MENU || (exports.MESSAGE_CONTEXT_MENU = MESSAGE_CONTEXT_MENU = {}));
var NON_CONTEXT_MENU_ACTION;
(function (NON_CONTEXT_MENU_ACTION) {
    NON_CONTEXT_MENU_ACTION["ADD_MEMBER"] = "ADD_MEMBER";
    NON_CONTEXT_MENU_ACTION["REVOKE_REFERRAL"] = "REVOKE_REFERRAL";
})(NON_CONTEXT_MENU_ACTION || (exports.NON_CONTEXT_MENU_ACTION = NON_CONTEXT_MENU_ACTION = {}));
var REMINDER_ACTIONS;
(function (REMINDER_ACTIONS) {
    REMINDER_ACTIONS["REMIND_AGAIN"] = "REMIND_AGAIN";
    REMINDER_ACTIONS["REVOKE"] = "REVOKE";
})(REMINDER_ACTIONS || (exports.REMINDER_ACTIONS = REMINDER_ACTIONS = {}));
exports.askAcknowledgementAllowedTypes = [
    models_1.MESSAGE_TYPE.PRIORITY,
    models_1.MESSAGE_TYPE.ACKNOWLEDGED,
];
